import Home from "./Home"
import React from "react"
import {
    Route,
    Routes,
    useLocation
} from "react-router-dom"
import { GetCurrentUser } from "./utils/hooks"
import {
    StockLayout,
    ClassStudents,
    RegisteredStudents,
    CreateClass
} from "./StockManager/index"
import {
    StackLayer,
    PlatformSetup,
    CreateRegistrationLink,
    PlatformFeeStructure,
    TemplateSelector
} from "./SettingStack/index"
import {
    LoginPage,
    SignupPage,
    AuthStack
} from "./User/index"
import {
    AdmitRoot,
    StudentAdmit
} from "./AdmitCard/index"
import {
    RegisterStudents,
    PublicRootLayer,
    LandingPage,
    FeatureInfo,
    FeatureLayer,
    ServicesPage,
    LoginPage as CLogin,
    NewStudentForm,
    PublicResults,
    StudentRegistration,
    StudentsRegistrationForm,
    PublicAdmitCard,
    ConnectWithUs,
    DownloadRegistrationReciept,
    AboutUs
} from "./public/index"
import {
    CertificateRoot,
    BonofideCertificateForm,
    SchoolLeavingForm,
    CharacterCertificateForm,
    SportCertificateForm,
    ProvisionalCertificateForm,
    PromotionCertificateForm,
    TransferCertificateForm
} from "./Certificates/index"
import {
    AdminRoot,
    CreateClient,
    ClientList,
    PlatformFee,
    Billing,
    Database
} from "./AdminPanel/index"
import {
    SubjectRootLayout,
    ManageSubjects
} from "./Subjects/index"
import {
    ExamRoot,
    CreateExamTimetablePage,
    ManageExamsPage,
    EditExamDetails
} from "./Exam/index"
import {
    FeeRoot,
    FeeCollector,
    Reports
} from "./FeeManager"
import {
    LectureRoutes,
    ManageCourses,
    CourseBuilder
} from "./Lectures/index"
import ResultRoot from "./Result/ResultsRoot"
import PageNotFound from "./NonRoure"

export default function Routing() {
    const path = useLocation()
    const [user, setUser] = React.useState(null)
    React.useEffect(() => {
        const user = GetCurrentUser()
        if (!user) {
            setUser(null)
        } else {
            setUser(user)
        }
    }, [path?.pathname])

    if (!user) {
        return (
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/feature" element={<FeatureLayer />} >
                    <Route path=":f" element={<FeatureInfo />} />
                </Route>
                <Route path="/about-us" element={<AboutUs/>} />
                <Route path="/service" element={<ServicesPage />} />
                <Route path="/auth" element={<CLogin />} />
                <Route path="/auth/login" element={<LoginPage />} />
                <Route path="/auth/signup" element={<SignupPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/results" element={<PublicResults />} />
                <Route path="/results/:school_id/:class_id/:exam_id/:student_id" element={<PublicResults />} />
                <Route path="/admit" element={<PublicAdmitCard />} />
                <Route path="/admit/:school_id/:class_id/:exam_id/:student_id" element={<PublicAdmitCard />} />
                <Route path="/registration" element={<StudentRegistration />} />
                <Route path="/registration/:data" element={<StudentsRegistrationForm />} />
                <Route path="/registrations/:institution_id/:class/:link_id" element={<NewStudentForm />} />
                <Route path="/connect_with_us" element={<ConnectWithUs />} />
                <Route path="/completed_registration" element={<DownloadRegistrationReciept />} />
                {/* Lecture portal: its own auth, independent of staff sessions */}
                <Route path="/learn/*" element={<LectureRoutes />} />
                <Route path="*" element={<PageNotFound />} />
            </Routes>
        )
    }



    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admit/:school_id/:class_id/:exam_id/:student_id" element={<PublicAdmitCard />} />
            <Route path="/stock" element={<StockLayout />}>
                <Route path="registered_students" element={<RegisteredStudents />} />
                <Route path="class_students" element={<ClassStudents />} />
            </Route>
            <Route path="create_class" element={<CreateClass />} />
            <Route path="/setting" element={<StackLayer />}>
                <Route path="platform" element={<PlatformSetup />} />
                <Route path="student_registration" element={<CreateRegistrationLink />} />
                <Route path="fee_structure" element={<PlatformFeeStructure />} />
                <Route path="certificate_template" element={<TemplateSelector />} />
            </Route>
            <Route path="/auth" element={<AuthStack />}>
                <Route path="login" element={<LoginPage />} />
                <Route path="signup" element={<SignupPage />} />
            </Route>
            <Route path="/admit" element={<AdmitRoot />}>
                {/* <Route path="template" element={<AdmitCardPlayground />} /> */}
                <Route path="classes" element={<StudentAdmit />} />
            </Route>

            <Route path="/public" element={<PublicRootLayer />} >
                <Route path="register" element={<RegisterStudents />} />
            </Route>
            <Route path="/admin" element={<AdminRoot />} >
                <Route path="new" element={<CreateClient />} />
                <Route path="client_list" element={<ClientList />} />
                <Route path="fee_setting" element={<PlatformFee />} />
                <Route path="billing" element={<Billing />} />
                <Route path="database" element={<Database />} />
            </Route>
            <Route path="/subjects" element={<SubjectRootLayout />} >
                <Route path=":class_name" element={<ManageSubjects />} />
            </Route>
            <Route path="/exam" element={<ExamRoot />} >
                <Route path="create" element={<CreateExamTimetablePage />} />
                <Route path="manage" element={<ManageExamsPage />} />
                <Route path=":examInfo" element={<EditExamDetails />} />
            </Route>
            <Route path="/fee" element={<FeeRoot />} >
                <Route path=":class_name" element={<FeeCollector />} />
                <Route path="reports" element={<Reports />} />
            </Route>
            <Route path="/result" element={<ResultRoot />} />
            <Route path="/lectures" element={<ManageCourses />} />
            <Route path="/lectures/course/:course_id" element={<CourseBuilder />} />
            {/* Students reach the portal at the same URL whoever is signed in */}
            <Route path="/learn/*" element={<LectureRoutes />} />
            <Route path="/results/:school_id/:class_id/:exam_id/:student_id" element={<PublicResults />} />
            <Route path="/certificates" element={<CertificateRoot />} >
                <Route path="BonafideCertificate" element={<BonofideCertificateForm />} />
                <Route path="leavingCertificates" element={<SchoolLeavingForm />} />
                <Route path="characterCertificate" element={<CharacterCertificateForm />} />
                <Route path="sportsCertificate" element={<SportCertificateForm />} />
                <Route path="ProvisionalCertificate" element={<ProvisionalCertificateForm />} />
                <Route path="promotionCertificate" element={<PromotionCertificateForm />} />
                <Route path="TransferCertificate" element={<TransferCertificateForm />} />
            </Route>
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    )
}
